import { Alert, AlertTitle } from '@mui/material';
import {
  BenefitActivationDTO,
  BenefitDTOBenefitEnum,
  BenefitTemplateItemDTO,
  CreateBenefitActivationDTO,
  UpdateBenefitActivationDTO,
} from 'probonio-shared-ui/api';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BenefitActivationDialogExtensionInterface } from '../../../../extension/interface/benefit-activation-dialog.extension.interface';
import { ActivationDialogExtensions } from '../../ActivationDialog';
import { isITLeasingPreconditionMet, useITLeasingPrecondition } from '../useITLeasingPrecondition';

interface ItLeasingBenefitOptions {}

const Fields: React.FC = () => {
  const { setError, clearErrors } = useFormContext();
  const { isPreconditionMet } = useITLeasingPrecondition();
  const { t } = useTranslation('benefitsModule');

  useEffect(() => {
    if (!isPreconditionMet) {
      setError('root', {
        message: 'error',
      });
    } else {
      clearErrors('root');
    }
  }, [clearErrors, isPreconditionMet, setError]);

  return isPreconditionMet ? (
    <Alert severity="info">
      <AlertTitle>{t('IT_LEASING.activate.alert.infoTitle')}</AlertTitle>
      <Trans
        i18nKey="benefitsModule:IT_LEASING.activate.alert.infoDescription"
        components={{
          settings: <Link to="/benefits/it_leasing/settings" />,
        }}
      />
    </Alert>
  ) : (
    <Alert severity="warning">
      <AlertTitle>{t('IT_LEASING.activate.alert.title')}</AlertTitle>
      <Trans
        i18nKey="benefitsModule:IT_LEASING.activate.alert.description"
        components={{
          settings: <Link to="/benefits/it_leasing/settings" />,
        }}
      />
    </Alert>
  );
};

const createITLeasingBenefitActivation: ActivationDialogExtensions<ItLeasingBenefitOptions>['onCreateActivation'] = async (
  baseValues,
  benefitOptions,
  saveActivation,
) => {
  const create: CreateBenefitActivationDTO = {
    ...baseValues,
    benefit: BenefitDTOBenefitEnum.ItLeasing,
  };
  await saveActivation(create);
};

const updateITLeasingBenefitActivation: ActivationDialogExtensions<ItLeasingBenefitOptions>['onUpdateActivation'] = async (
  baseValues,
  benefitOptions,
  saveActivation,
) => {
  const update: UpdateBenefitActivationDTO = {
    ...baseValues,
  };
  await saveActivation(update);
};

const resetITLeasingBenefitOptions = (selectedActivation?: BenefitActivationDTO | BenefitTemplateItemDTO): ItLeasingBenefitOptions => {
  return {};
};

export class ITLeasingBenefitActivationDialogExtension extends BenefitActivationDialogExtensionInterface<ItLeasingBenefitOptions> {
  CreateFields?: React.ReactNode = (<Fields />);
  ChangeOptionsFields?: React.ReactNode = (<Fields />);

  onCreateActivation = createITLeasingBenefitActivation;
  onUpdateActivation = updateITLeasingBenefitActivation;
  onResetBenefitOptions = resetITLeasingBenefitOptions;
  isPreconditionMet = isITLeasingPreconditionMet;
}
